import React, { useEffect, useState } from "react";
import Logo from '../assets/Logo.svg';
import { auth } from '../firebase-config'
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth'
import { useNavigate } from "react-router-dom";
import { clearPageMessage, showLoadingMessage, showSuccessMessage, showWarningMessage } from '../successMessage';

const Login = () => {

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState('')

  const navigate = useNavigate()

  const handleLogin = async () => {
    try {
      setLoading(true)
      showLoadingMessage('Signing In')
      const { user } = await signInWithEmailAndPassword(auth, email, password)
      console.log('user', user)
      setLoading(false)
      showSuccessMessage('Signed in successfully')
    } catch (e) {
      clearPageMessage()
      showWarningMessage('Sign in failed. Check your email and password and try again.')
      setLoading(false)
      console.error('e', e)
    }
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid
        navigate('/admin')
      } else {
        // User is signed out
        // ...
      }
    })

    return () => unsubscribe()
  }, [])


  return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
    <div style={{ display: 'flex', flexDirection: 'column', width: '350px', alignItems: 'center' }}>
      <img src={Logo} style={{ width: '200px', marginLeft: '20px' }} />

      <h1 style={{ fontSize: '31px' }}>Login</h1>
      <input type="email" id="email" required name="email" placeholder="email@domain.com.au" value={email} onChange={({ target }) => setEmail(target.value)} />
      <input type="password" id="password" required name="password" placeholder="Password" value={password} onChange={({ target }) => setPassword(target.value)} />
      <button disabled={loading} onClick={handleLogin}>{loading ? 'Loading...' : 'Login'}</button>
    </div>
  </div>
}

export default Login
